import ContextIcon from '@mui/icons-material/VideogameAsset';

export default ContextIcon;
